<div
  class="fk-tag"
  [class.disable-tag]="disable"
  [class.selected-tag]="selected"
  [ngClass]="getPaddingCls()"
>
  <button
    *ngIf="removable"
    class="fk-tag__remove-btn"
    (click)="removeEvent($event)"
  >
    <fk-icon [size]="12" name="close" />
  </button>
  <div class="fk-tag__content fk-text">
    <ng-content></ng-content>
  </div>
</div>
